const routes = {
  "Эрмитаж - Пулково (LED)": [
    [30.316273, 59.940578],
    [30.316589, 59.940495],
    [30.322104, 59.942886],
    [30.324488, 59.941109],
    [30.328283, 59.940693],
    [30.326199, 59.935318],
    [30.360826, 59.930965],
    [30.339552, 59.90173],
    [30.341515, 59.894806],
    [30.361811, 59.855789],
    [30.380919, 59.818024],
    [30.379545, 59.81636],
    [30.370289, 59.815208],
    [30.35289, 59.81477],
    [30.3368, 59.810448],
    [30.334572, 59.810379],
    [30.323389, 59.812008],
    [30.32362, 59.806255],
    [30.324347, 59.793816],
    [30.317898, 59.790894],
    [30.280516, 59.797192],
    [30.275146, 59.800365],
    [30.274046, 59.800365],
    [30.272182, 59.800652]
  ],

  "Кинотеатр Аврора - Пулково (LED)": [
    [30.3398, 59.934521],
    [30.341167, 59.934372],
    [30.341, 59.933601],
    [30.335127, 59.93433],
    [30.320229, 59.927803],
    [30.317333, 59.926697],
    [30.321224, 59.844273],
    [30.324347, 59.793816],
    [30.317898, 59.790894],
    [30.280516, 59.797192],
    [30.275146, 59.800365],
    [30.274046, 59.800365],
    [30.272182, 59.800652]
  ],

  "Мариинский театр - Пулково (LED)": [
    [30.296064, 59.926102],
    [30.295998, 59.926178],
    [30.296774, 59.926144],
    [30.299091, 59.923546],
    [30.286839, 59.920956],
    [30.279137, 59.916134],
    [30.27503, 59.908867],
    [30.25832, 59.909126],
    [30.252645, 59.904724],
    [30.247093, 59.904057],
    [30.240889, 59.894974],
    [30.245876, 59.893478],
    [30.256395, 59.887089],
    [30.289454, 59.880245],
    [30.294506, 59.877121],
    [30.290562, 59.852345],
    [30.280144, 59.835918],
    [30.275133, 59.833431],
    [30.278881, 59.834045],
    [30.31538, 59.814285],
    [30.323488, 59.808533],
    [30.324347, 59.793816],
    [30.317898, 59.790894],
    [30.280516, 59.797192],
    [30.275146, 59.800365],
    [30.274046, 59.800365],
    [30.272182, 59.800652]
  ],

  "Эрмитаж - Кинотеатр Аврора": [
    [30.316273, 59.940578],
    [30.316589, 59.940495],
    [30.320316, 59.942169],
    [30.325672, 59.94429],
    [30.332203, 59.945786],
    [30.335087, 59.941833],
    [30.336704, 59.93922],
    [30.336357, 59.937344],
    [30.340454, 59.938164],
    [30.341677, 59.938072],
    [30.341167, 59.934372],
    [30.3398, 59.934521]
  ],

  "Эрмитаж - Мариинский театр": [
    [30.316273, 59.940578],
    [30.316589, 59.940495],
    [30.318521, 59.941391],
    [30.319433, 59.940792],
    [30.318914, 59.939056],
    [30.319357, 59.93626],
    [30.315538, 59.936707],
    [30.315027, 59.936684],
    [30.314781, 59.936363],
    [30.305826, 59.93325],
    [30.308367, 59.931438],
    [30.308252, 59.929344],
    [30.296511, 59.926609],
    [30.296774, 59.926144],
    [30.295998, 59.926178],
    [30.296064, 59.926102]
  ],

  "Кинотеатр Автора - Мариинский театр": [
    [30.3398, 59.934521],
    [30.341167, 59.934372],
    [30.341, 59.933601],
    [30.335127, 59.93433],
    [30.334736, 59.933899],
    [30.320229, 59.927803],
    [30.31184, 59.924282],
    [30.303511, 59.924446],
    [30.299219, 59.923573],
    [30.295881, 59.927311],
    [30.296774, 59.926144],
    [30.295998, 59.926178],
    [30.296064, 59.926102]
  ]
};

export const getRoute = (address1, address2) => {
  const route = routes[`${address1} - ${address2}`];
  if (route) {
    return route;
  }
  const reverseRoute = routes[`${address2} - ${address1}`];
  if (reverseRoute) {
    return reverseRoute.reverse();
  }
};

export const auth = (body) => {
  return fetch("https://loft-taxi.glitch.me/auth", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  }).then(res => res.json());
};
